const ASSIGNEE_TYPE_ORDER = { user: 0, team: 1 };
const compareAssignees = (left, right) => ASSIGNEE_TYPE_ORDER[left.type] - ASSIGNEE_TYPE_ORDER[right.type] || left.label.localeCompare(right.label, void 0, { sensitivity: "base" });
export const assigneeSuggestions = (assignees, { query, page, pageSize }) => {
  const normalizedQuery = query.trim().toLowerCase();
  const matchingAssignees = assignees.filter(({ label }) => label.toLowerCase().includes(normalizedQuery)).sort(compareAssignees);
  const pageStart = (page - 1) * pageSize;
  return {
    total: matchingAssignees.length,
    suggestions: matchingAssignees.slice(pageStart, pageStart + pageSize).map(({ id, label }) => ({ id, value: label }))
  };
};
